import { useEffect, useState } from "react";
import { Bone, Dog } from "lucide-react";
import Reveal from "./Reveal";
import PawTrail from "./PawTrail";

const GallerySection = () => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/gallery`)
      .then((r) => r.json())
      .then((d) => setItems(d))
      .catch(() => setItems([]));
  }, []);

  return (
    <section id="gallery" className="mx-auto max-w-[1440px] px-6 py-24 md:px-12 md:py-32">
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-marmalade">The gallery</p>
          <h2 className="mt-4 max-w-xl font-display text-4xl font-medium leading-[1.02] tracking-tight text-ink md:text-6xl">
            Recent <em className="text-marmalade">happy</em> tails
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="hidden w-64 md:block">
          <PawTrail count={5} opacityClass="opacity-25" color="text-forest" />
        </Reveal>
      </div>

      {items === null && <p className="mt-14 text-inkSoft">Fetching the gallery…</p>}
      {items?.length === 0 && (
        <div className="mt-14 flex flex-col items-center gap-4 rounded-3xl border border-dashed border-line bg-white/60 px-6 py-20 text-center" data-testid="gallery-empty">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-sand">
            <Dog className="h-6 w-6 text-marmalade" />
          </span>
          <p className="font-display text-2xl text-ink">The gallery is being furnished</p>
          <p className="max-w-xs text-sm text-inkSoft">Photos of Ari's recent guests will appear here soon.</p>
        </div>
      )}

      <div className="mt-14 grid grid-cols-2 gap-4 md:gap-6 lg:grid-cols-4">
        {items?.map((item, i) => (
          <Reveal key={item.id} delay={(i % 4) * 0.07} className={i % 5 === 0 ? "sm:row-span-2" : ""}>
            <figure
              className="group relative h-full overflow-hidden rounded-[1.6rem] border border-line bg-white shadow-[0_8px_30px_rgba(42,42,42,0.04)]"
              data-testid={`gallery-item-${item.id}`}
            >
              <img
                src={item.image}
                alt={item.title}
                className={`w-full object-cover transition-transform duration-700 group-hover:scale-[1.05] ${
                  i % 5 === 0 ? "h-72 sm:h-full sm:min-h-[420px]" : "h-52 md:h-60"
                }`}
              />
              <figcaption className="absolute inset-x-3 bottom-3 rounded-2xl bg-cream/90 px-4 py-2.5 backdrop-blur-md">
                <span className="block text-sm font-semibold text-ink">{item.title}</span>
                {item.caption && <span className="block text-xs text-inkSoft">{item.caption}</span>}
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default GallerySection;
